import { useContext, useEffect, useRef } from "react";
import { Context } from "../../context/Context";
import TransactionsList from "../TransactionsList";

const TransactionsModal = () => {
  const { transactionsModal, setTransactionsModal } = useContext(Context);
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    setTransactionsModal(modalRef);
  }, []);

  return (
    <div
      className="modal fade"
      id="transactionsModal"
      tabIndex="-1"
      aria-labelledby="transactionsModalLabel"
      aria-hidden="true"
      ref={modalRef}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          {/* <div className="modal-header">
            <h5 className="modal-title" id="transactionsModalLabel">
              <i className="bx bx-history me-2"></i>
              لیست تراکنش‌ها
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButtonRef}
            ></button>
          </div> */}
          <div className="modal-body" style={{paddingTop: '0.75rem', paddingBottom: '0.75rem'}}>
            <TransactionsList />
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TransactionsModal;